<div class="part-exchange">
	<!--  STEP HEADER  -->

	<cng-step-header
		[current_step_key]="current_step_key"
		[location]="'engage_configure'"
		(jump)="jumpTo($event)"
	></cng-step-header>

	<!--  END STEP HEADER  -->

	<div class="container">
		<!--  HEADING - NO PART EXCHANGE  -->

		<div *ngIf="!has_part_exchange && pex_vehicle_state === null" class="heading">
			<ui-concierge
				data-element-view="concierge__engage_configure_part_exchange_step__[Do you have a part exchange vehicle?]"
			>
				<h1>Do you have a part exchange vehicle?</h1>
				<p class="hidden-xxs hidden-xs">We offer competitive valuations on all used vehicles.</p>
				<p class="hidden-xxs hidden-xs margin-top-0">
					Use your current vehicle as a contribution towards your new one, or if you don't have a part
					exchange simply skip this step.
				</p>
			</ui-concierge>
		</div>

		<div *ngIf="!has_part_exchange && pex_vehicle_state === 'a'" class="heading">
			<ui-concierge
				data-element-visibility="concierge__part_exchange_step[lookup]__[Enter your registration number below...]"
			>
				<div class="hidden-sm hidden-md hidden-lg hidden-xl">
					<h1>Enter your registration number below...</h1>
				</div>
				<div class="hidden-xxs hidden-xs">
					<h1>Let's find the vehicle you want to trade in.</h1>
					<p>Enter your registration number below and we will find your vehicle.</p>
				</div>
			</ui-concierge>
		</div>

		<div *ngIf="!has_part_exchange && pex_vehicle_state === 'b'" class="heading">
			<ui-concierge
				data-element-view="concierge__engage_configure_part_exchange_step[details]__[We need a few more details to help value your part exchange...]"
			>
				<h1>We need a few more details to help value your part exchange...</h1>
				<p class="hidden-xxs hidden-xs hidden-sm">
					Fill in the information below to help us give you an accurate valuation.
				</p>
			</ui-concierge>
		</div>

		<!--  END HEADING - NO PART EXCHANGE  -->

		<!--  HEADING - HAS PART EXCHANGE  -->

		<div *ngIf="has_part_exchange" class="heading">
			<ui-concierge
				data-element-view="concierge__engage_configure_part_exchange_step[completed]__[See your part exchange details below.]"
			>
				<h1>See your part exchange details below.</h1>
				<p class="hidden-xxs hidden-xs hidden-sm">
					If you wish to discuss your part exchange in more details please get in touch.
				</p>
			</ui-concierge>
		</div>

		<!--  END HEADING - HAS PART EXCHANGE  -->
	</div>

	<!--  PART EXCHANGE LOOP  -->

	<div *ngIf="part_exchanges.length > 0" class="vehicles">
		<cng-part-exchange-vehicle
			*ngFor="let p of part_exchanges"
			[pex_vehicle]="p"
			(remove)="onRemove(p)"
			(show_valuation)="onShowValuation($event, p)"
		></cng-part-exchange-vehicle>
	</div>

	<!--  END PART EXCHANGE LOOP  -->

	<!--  ADD PART EXCHANGE BUTTON  -->

	<div *ngIf="part_exchanges.length !== 1" class="container button-container">
		<a
			class="button block-button positive-button button-with-icon-right"
			data-element-click="button__engage_configure_part_exchange__positive-button[Add Part Exchange]"
			(click)="addNewPartExchange()"
		>
			<span class="text">Add Part Exchange</span>
			<i class="icon-add"></i>
		</a>

		<a
			*ngIf="hasFollowingSteps()"
			class="button block-button minor-button button-with-icon-right"
			data-element-click="button__engage_configure_part_exchange__minor-button[Skip This Step]"
			(click)="onSkipThisStep()"
		>
			<span class="text">Skip This Step</span>
			<i class="icon-arrow-right"></i>
		</a>
	</div>

	<!--  END ADD PART EXCHANGE BUTTON  -->

	<!-- END VALUATION MODAL  -->

	<!--  STEP BAR  -->

	<cng-step-bar
		[current_step_key]="current_step_key"
		[show_next]="hasFollowingSteps()"
		(jump)="jumpTo($event)"
	></cng-step-bar>

	<!--  END STEP BAR  -->

	<!--  SCROLL FADES  -->

	<div class="scroll-fade top"></div>
	<div class="scroll-fade bottom"></div>

	<!--  END SCROLL FADES  -->
</div>
